export default {
  zh: {
    programOverview: '项目介绍',
    overViewInfo: 'Plex加速器联盟推广会员可以通过个人网站、邮箱或者其他电子营销手段推广我们的服务以获取高额佣金。',
    duty: '责任与义务',
    dutyInfo: '开始推广之前，您需要先在我们网站上完成您的联盟会员申请。联盟账号申请时所提供的信息请务必保证真实有效。每个人只能申请一个联盟推广账号。如果您在推广过程中，违反了我们的联盟推广政策，我们有权取消账号，佣金清零。',
    dutyList: [
      '不允许通过任何形式的误导、诽谤、非法活动或者任何跟我们联盟政策相悖的手段推广Plex加速器；',
      '不能损害Plex加速器的品牌形象；',
      '不能鼓励用户参与任何非法活动推广Plex加速器；',
      '宣传推广材料严禁包含任何损害版权、商标或者其他知识产权的内容；',
      '严禁通过以下方式宣传推广：'
    ],
    unsuitableList: [
      '垃圾邮件，在社交媒体、博客、论坛或者其他评论系统上发布垃圾信息；',
      '任何违反或者带有欺骗性质的营销手段；',
      '不当的广告方式：严禁在搜索引擎（谷歌，百度，必应，等）上投放包含Plex加速器品牌词以及品牌词错拼的竞价广告。不允许在任何竞价广告项目（如Google Adwords，百度竞价）中使用个人联盟链接。严禁投放包含品牌词的广告，包括但并不仅限于Plex加速器, Plex 加速器等。严禁投放品牌词+关键词，如“Plex加速器+关键词”。严禁投放直链广告。'
    ],
    remind: '所有违反推广政策的联盟推广会员，一经发现，佣金清零，并且禁止再次参与Plex加速器联盟推广项目。',
    acceptableMethods: '允许广告推广方式',
    fallowingMethods: '以下广告方式是允许的：',
    methodsList: [
      '在自己的网站上发布文本链接、组件、横幅标语等；',
      '通过社交媒体工具分享个人联盟链接或者邀请码。'
    ],
    modification: '服务条款变更',
    modificationInfo: '本平台保留随时修改本服务条款，有关修改会在本平台作出公告。您有责任熟悉本平台的服务条款。如您继续使用本平台，即被视为已同意该等修改。'
  },
  en: {
    programOverview: 'Program Overview',
    overViewInfo: 'The purpose of the Program is to permit you to advertise PlexVPN services on your Site, in Email or any other form of electronic marketing, and to receive a commission on services purchased by your referred individuals.',
    duty: 'Affiliate Obligations',
    dutyInfo: 'To begin the enrollment process you must complete an affiliate application via our site. All information associated with your affiliate account must be real and verifiable. You are allowed to use only one affiliate account unless approved by PlexVPN to use more than one account. We may reject or cancel your application, in our sole discretion, if we decide your site or/and your participation in our program is unsuitable. These may include but are not limited to any media that will:',
    dutyList: [
      'Promote our services in a manner that contains any form of misleading, defamatory, illegal activities or any other content deemed offensive by us;',
      'Cause damage to the PlexVPN brand name;',
      'Promote our services in a manner that encourages a user to register for the purpose of engaging in any illegal activity;',
      'Incorporate any materials which infringe any copyright, trademark or other intellectual property rights;',
      'Unsuitable participation in the program includes:'
    ],
    unsuitableList: [
      'Spam Emails, spamming on social media, blogs, forums or any other commenting system;',
      'Any illegal or deceptive type of marketing;',
      'Improper Advertising Methods: You may not bid for competing keywords that include any variations of PlexVPN or misspellings in PPC programs on search engines (Google, Baidu, Bing, etc.). You may not use your affiliate links in any PPC programs such as Google AdWords. You are not allowed to bid on any trademark keywords such as but not exclusive of PlexVPN, Plex VPN. Any variations or misspellings are also prohibited. You are not allowed to use TM + keywords such as "PlexVPN + keyword". You are not allowed to direct link.'
    ],
    remind: 'If a PlexVPN affiliate is found attempting to circumvent or violate these rules, they will have their commissions voided and will not receive payments. They will additionally be permanently banned from the PlexVPN Affiliate Program. We show no mercy when it comes to spammers.',
    acceptableMethods: 'Acceptable Advertising Methods',
    fallowingMethods: 'You may advertise our services via:',
    methodsList: [
      'Text links, widgets, graphical banners, or other affiliate linking tools on your site;',
      'Share your referral link or invitation code via electronic messaging systems or other media.'
    ],
    modification: 'Modification',
    modificationInfo: 'This Agreement may be amended at any time by us from time to time without specific notice to you. Changes take effect when we post them on the Platform. You should therefore read these Terms of Service before you use through the site.'
  }
}



// WEBPACK FOOTER //
// ./src/components/affiliatePolicy/lang.js